import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { useLocation, useMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { rolesList } from "Components/Router/Permission";
import { useEffect, useState } from "react";
import { coordinatorPath } from '../../Layout/AppNav/helpers.js';

function insertComma(name) {

    if (!name) {
        console.warn("insertComma received invalid value:", name);
        return "";
    }

    const words = name.trim().split(" ");

    if (words.length > 2) {
        return `${words[0]} ${words[1]}, ${words.slice(2).join(" ")}`;
    }

    return name;
}

const AppBreadcrumb = ({ additionalBreadcrumbs, useDefaultPath = true, data, orgName, schoolName }) => {
    const userRoles = useSelector((state) => state.UserPermission);
    const route = useLocation();
    const breadcrumbs = useBreadcrumbs();
    let match = useMatch("/searchsubrequests/:substitute");
    const [link, setLink] = useState('');

    useEffect(() => {
        const matchedRole = Object.values(rolesList).find(role =>
            userRoles.roles.includes(role.name)
        );

        if (matchedRole) {
            setLink(matchedRole.route);
        }
    }, [userRoles.roles]);

    return (
        <div>
            <div className="breadcrumb-main">
                <Breadcrumb color="light">
                    <BreadcrumbItem color="light">
                        <a href={`#${link}`} >
                            <FontAwesomeIcon icon={faHome} />
                        </a>
                    </BreadcrumbItem>
                    {useDefaultPath
                        ? breadcrumbs.map((breadcrumb, index) => {

                            const isDagdelenToevoegenRoute =
                                /^\/verzoeken\/\d+\/dagdelen-toevoegen$/.test(route.pathname) ||
                                /^\/verzoeken\/overzicht\/\d+\/dagdelen-toevoegen$/.test(route.pathname);

                            if (
                                isDagdelenToevoegenRoute &&
                                (
                                    /^\/verzoeken\/\d+$/.test(breadcrumb.key) ||
                                    /^\/verzoeken\/overzicht\/\d+$/.test(breadcrumb.key) ||
                                    (
                                        /^\/verzoeken\/overzicht\/\d+\/dagdelen-toevoegen$/.test(route.pathname) &&
                                        breadcrumb.key === "/verzoeken/overzicht"
                                    )
                                )
                            ) {
                                return null;
                            }

                            if (
                                breadcrumb.key.startsWith('/verzoeken/vervanger-zoeken') &&
                                (breadcrumb.key.split('/').length === 4 || breadcrumb.key.split('/').length === 5 || breadcrumb.key.split('/').length === 6)
                            ) {
                                return null;
                            }
                            const parts = route.pathname.split('/');
                            const idFromUrl = parts.length >= 4 ? parts[3] : null;

                            if (

                                breadcrumb.key.startsWith('/verzoeken/vervanger-zoeken') &&
                                parts.length === 4
                            ) {
                                return null;
                            }

                            if (breadcrumb.key === '/verzoeken/vervanger-zoeken' && idFromUrl) {
                                return (
                                    <>
                                        <BreadcrumbItem key={`id-${idFromUrl}`} color="light">
                                            <a href={`#/verzoeken/overzicht/${idFromUrl}`}>
                                                <span>{idFromUrl}</span>
                                            </a>
                                        </BreadcrumbItem>
                                        <BreadcrumbItem key={breadcrumb.key} color="light">
                                            <a><span>Vervanger zoeken</span></a>
                                        </BreadcrumbItem>
                                    </>

                                );
                            }

                            if (breadcrumb.breadcrumb.props.children == "Searchsubrequests") {
                                return (
                                    <BreadcrumbItem key={index} color="light">
                                        <a href={"#" + breadcrumb.key} >
                                            <span>Zoek resulaten</span>
                                        </a>
                                    </BreadcrumbItem>

                                )

                            } else if (breadcrumb.breadcrumb.props.children != "Home" && breadcrumb.key !== "/links/coordinator" && breadcrumb.key !== "/links/substitutor" && breadcrumb.key !== "/links/requestor") {

                                const isCoordinatorVerzoeken =
                                    route.pathname.startsWith('/verzoeken/overzicht') ||
                                    route.pathname.startsWith('/verzoeken/vervanger-zoeken') ||
                                    coordinatorPath.verzoeken.some(p => route.pathname.startsWith(p));

                                let link = breadcrumb.key;
                                if (breadcrumb.key === '/weekstaten') {
                                    link = '/weekstaten/overzicht';
                                }

                                if (breadcrumb.key.includes('/verzoeken')) {
                                    if (breadcrumb.key === '/verzoeken/planbord') {
                                        link = '/verzoeken/planbord';
                                    }
                                    else if (breadcrumb.key === '/verzoeken/indienen') {

                                        link = '/verzoeken/indienen';
                                    } else if (breadcrumb.key.split('/').length <= 3) {
                                        if (route.pathname === '/verzoeken/historie') {
                                            link = '/verzoeken';
                                        } else if (isCoordinatorVerzoeken) {
                                            link = '/verzoeken/overzicht';
                                        } else {
                                            link = '/verzoeken';
                                        }
                                    }
                                }

                                return (
                                    <BreadcrumbItem key={index} color="light">
                                        <a href={"#" + link} >
                                            {match !== null ? (
                                                <span>{route.state.name}</span>
                                            ) : (
                                                <span>
                                                    {
                                                        /^\/gebruikers\/\d+$/.test(breadcrumb.key)
                                                            ? `${insertComma(data?.data?.name)} (${breadcrumb.breadcrumb.props.children})`
                                                            : breadcrumb.breadcrumb.props.children === "V documenten" ? "Documenten" : breadcrumb.breadcrumb.props.children === "V reiskosten" ? "Reiskosten" : breadcrumb.breadcrumb.props.children === "C instellingen" ? "Instellingen" :
                                                                orgName ? `${breadcrumb.breadcrumb.props.children}${String.fromCharCode(160)} / ${String.fromCharCode(160)}${orgName}` :
                                                                    /^\/c-instellingen\/scholen\/[^/]+\/[^/]+$/.test(breadcrumb.breadcrumb.key) && schoolName ? schoolName :

                                                                        breadcrumb.location.pathname.includes("c-instellingen/contracttypen/wijzigen-toevoegen") ?
                                                                            (breadcrumb.breadcrumb.props.children === "Wijzigen toevoegen" ? 'Wijzigen/toevoegen' : breadcrumb.breadcrumb.props.children)
                                                                            : breadcrumb.breadcrumb.props.children
                                                    }
                                                </span>
                                            )
                                            }
                                        </a>
                                    </BreadcrumbItem>
                                )

                            } else if (breadcrumb.breadcrumb.props.children == "Home" && index == 1) {
                                return (
                                    <BreadcrumbItem key={index} color="light">
                                        <a href={"#" + breadcrumb.key} >
                                            {match !== null ? (
                                                <span>{route.state.name}</span>
                                            ) : (
                                                <span>{breadcrumb.breadcrumb.props.children} </span>
                                            )
                                            }
                                        </a>
                                    </BreadcrumbItem>

                                )
                            }
                        })
                        : additionalBreadcrumbs &&
                        additionalBreadcrumbs.map((breadcrumb) => (
                            <BreadcrumbItem key={breadcrumb.href} color="light">
                                <a href={breadcrumb.href}>{breadcrumb.label}</a>
                            </BreadcrumbItem>
                        ))}
                </Breadcrumb>
            </div>
        </div>
    );

}

export default AppBreadcrumb;
